import comp from "./EvidenceCard";
export default comp;
